// extracted by mini-css-extract-plugin
export default {"item":"style_item__tddB2","container":"style_container__pQEGd","policy_card_wrap":"style_policy_card_wrap__6gLUm","sum":"style_sum__PLbDw"};